import React from 'react';
import styles from './statusstyles.module.scss';
import PendingIcon from '../../../assets/images/status-icons/pending-status-icon.svg';
import CancelledIcon from '../../../assets/images/status-icons/cancelled-status-icon.svg';
import ApprovedIcon from '../../../assets/images/status-icons/approved-status-icon.svg';
import Proptypes from 'prop-types';

const StatusIndicator = ({ currentStatus }) => {
  const isApproved = currentStatus?.toLowerCase() === 'approve';
  const isPending = currentStatus?.toLowerCase() === 'pending';
  const isCancelled = currentStatus?.toLowerCase() === 'cancel';
  return (
    <div className={styles['status_outer_container']}>
      <div className={styles['status_container']}>
        <div>
          <img
            src={isApproved ? ApprovedIcon : isPending ? PendingIcon : CancelledIcon}
            width={24}
            height={24}
            alt="icon"
          />
        </div>
        <div
          className={
            isApproved
              ? styles['status_approved_container']
              : isPending
                ? styles['status_pending_container']
                : styles['status_cancelled_container']
          }
        >
          {isApproved ? 'Approved' : isCancelled ? 'Cancelled' : 'Pending'}
        </div>
      </div>
    </div>
  );
};

StatusIndicator.propTypes = {
  currentStatus: Proptypes.string,
};

export default StatusIndicator;
